import React, { useEffect, useState } from "react";
import { Modal, Table } from "antd";
import { getRopeUploadMessages } from "api/ropeApi";
import displayErrorNotification from "utils/displayErrorNotification";
import { ColumnProps } from "antd/lib/table";
import { RopeMessage, RopeUpload } from "types/Rope";
import { textOverflow } from "components/common/textOverflow";
import { convertRopeMessageData } from "utils/convert";
import { formatDateTime } from "utils/formatDateTime";
import { Link } from "react-router-dom";
import RopeMessageRecordModal from "./RopeMessageRecordModal";

type RopeMessagesModalProps = {
  modalState: boolean;
  closeModal: () => void;
  record: RopeUpload | null;
};

const RopeMessagesModal = (props: RopeMessagesModalProps) => {
  const [loading, setLoading] = useState(true);
  const [messages, setMessages] = useState<RopeMessage[] | null>(null);
  const [isRecordModalHidden, setIsRecordModalHidden] = useState(true);
  const [selectedRecord, setSelectedRecord] = useState<RopeMessage | null>(
    null
  );

  const handleRecordOpenModal = record => {
    setIsRecordModalHidden(!isRecordModalHidden);
    setSelectedRecord(record);
  };

  useEffect(() => {
    if (props.record) {
      setLoading(true);
      getRopeUploadMessages(props.record.id)
        .then(data => {
          const converted = convertRopeMessageData(data);
          setMessages(converted);
        })
        .catch(displayErrorNotification)
        .then(() => {
          setLoading(false);
        });
    }
  }, [props.record]);

  let columns: ColumnProps<RopeMessage>[] = [
    {
      title: "Level",
      dataIndex: "level",
      width: "60px"
    },
    {
      title: "Message",
      dataIndex: "message",
      render: message => textOverflow(message, 130)
    },
    {
      title: "Type",
      dataIndex: "type",
      width: "60px"
    },
    {
      title: "Created At",
      dataIndex: "createdAt",
      render: data => formatDateTime(data),
      width: "170px"
    },
    {
      title: "Created By",
      render: record => (
        <Link to={`/employees/${record.createdById}`}>{record.createdBy}</Link>
      )
    }
  ];

  return (
    <Modal
      title={"ROPE Messages"}
      visible={props.modalState}
      onCancel={props.closeModal}
      footer={null}
      width={"1500px"}
    >
      <Table
        onRow={r => {
          return {
            onClick: () => handleRecordOpenModal(r),
            style: { cursor: "pointer" }
          };
        }}
        rowKey="id"
        columns={columns}
        dataSource={messages || []}
        loading={loading}
        pagination={{ pageSize: 10, position: "top", hideOnSinglePage: true }}
      />
      {isRecordModalHidden ? null : (
        <RopeMessageRecordModal
          modalState={true}
          closeModal={() => setIsRecordModalHidden(true)}
          record={selectedRecord || null}
        />
      )}
    </Modal>
  );
};

export default RopeMessagesModal;
